import { type HUImage } from "@modules/types/imageTypes"

// TODO refactor to SlotSubscriber
export type Subscriber = {
  id: string
  memberId: string
  firstname: string
  lastname: string
  username: string
  avatar?: HUImage
  absent: boolean
  isBirthday: boolean
  isTrial: boolean
  isDropIn: boolean
  internalNote: string | null
}

export const ParticipantStatus = {
  REGISTERED: "REGISTERED",
  PENDING: "PENDING",
} as const

export type ParticipantStatus = (typeof ParticipantStatus)[keyof typeof ParticipantStatus]
